// extracted by mini-css-extract-plugin
export default {"SummaryHeader":"KeKBoR0iLYC2TnDKbaPA","Heading":"KpxZHnmi9F9RRHydLCEg","Button":"EIzSDz5pvMdZtfaxSz6u","ButtonIcon":"pBmfcn46jP30ejRxgekc"};